import React from 'react'
import { connect } from 'react-redux'
import c from 'classnames'

import * as F from 'discada/dist/Form'

import './AddVehicleForm.scss'

export function AddVehicleForm({ className, onCancel }) {
  return (
    <div className={c('add-vehicle-form', className)}>
      <h3>Add Vehicle</h3>

      <div className="fields-wrapper">
        <F.SelectField label="Year" />
        <F.SelectField label="Make" />
        <F.SelectField label="Model" />
        <F.SelectField label="Trim" />
      </div>

      <F.Controls
        saveLabel="Add Vehicle"
        onSave={onCancel}
        onCancel={onCancel}
      />
    </div>
  )
}

function mapStateToProps(state, op) {
  return { ...op }
}

export default connect(mapStateToProps)(AddVehicleForm)
